var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Density, Direction } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { array, oneOf } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { classNames, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { Field } from '../field/field.js';
import { Text } from '../text/text.js';
import ValueListAPI from './value-list-api.js';
import './value-list.css';
let ValueList = class ValueList extends Component {
    getClassName() {
        const { direction, density } = this.props;
        return classNames({
            'c-value-list': true,
            [`c-value-list--${direction}`]: isEnumValid(Direction, direction),
            [`c-value-list--${density}`]: isEnumValid(Density, density),
        });
    }
    renderValues() {
        const { data } = this.props;
        if (!Array.isArray(data)) {
            return null;
        }
        return data.map(({ label, value }, index) => (React.createElement("li", { className: "c-value-list__item", key: `${index}-${value}` },
            React.createElement(Field, { entry: "fake-entry", label: label, uuid: "fake-uuid", width: 0 }, Array.isArray(value)
                ? value.map((text, index) => React.createElement(Text, { className: "u-truncate", key: index }, text))
                : React.createElement(Text, { className: "u-truncate" }, value)))));
    }
    render() {
        return (React.createElement("div", { className: this.getClassName() },
            React.createElement("ul", { className: "c-value-list__items" }, this.renderValues())));
    }
};
ValueList.propTypes = {
    data: array.notEnumerable(),
    density: oneOf(Object.values(Density)),
    direction: oneOf(Object.values(Direction)),
};
ValueList.defaultProps = {
    data: [],
    density: Density.REGULAR,
    direction: Direction.HORIZONTAL,
};
ValueList = __decorate([
    AwesomeComponent({ api: ValueListAPI, type: ComponentType.LIST })
], ValueList);
export { ValueList, };
export default ValueList;
//# sourceMappingURL=value-list.js.map